/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { LocalizationKeys } from "./Constants/LocalizationKeys";
import { FetchClient } from "@cxp-shared/fetch-client";
var PlaceholderMetadataProvider = /** @class */ (function () {
    function PlaceholderMetadataProvider(crmUrl, lcid, localize) {
        this.crmUrl = crmUrl;
        this.lcid = lcid;
        this.localize = localize;
    }
    PlaceholderMetadataProvider.prototype.getEntityProviders = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, languageCode, getProvidersRequest, rawResult, result, resultObject;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.crmUrl).concat(PlaceholderMetadataProvider.odataEndpoint).concat(PlaceholderMetadataProvider.entityProvidersEndpoint);
                        languageCode = this.lcid;
                        getProvidersRequest = JSON.stringify({ languageCode: languageCode });
                        return [4 /*yield*/, PlaceholderMetadataProvider.fetchClient.fetchPost(url, { GetProvidersRequest: getProvidersRequest })];
                    case 1:
                        rawResult = _a.sent();
                        if (!rawResult.ok) {
                            throw new Error(this.localize(LocalizationKeys.ErrorPersonalizationEntityProviders));
                        }
                        return [4 /*yield*/, rawResult.json()];
                    case 2:
                        result = _a.sent();
                        resultObject = JSON.parse(result.GetProvidersResult);
                        if (resultObject == null) {
                            throw new Error(this.localize(LocalizationKeys.ErrorPersonalizationEntityProvidersResponseIsNull));
                        }
                        return [2 /*return*/, new Map(Object.keys(resultObject).map(function (key) { return [key, resultObject[key]]; }))];
                }
            });
        });
    };
    PlaceholderMetadataProvider.prototype.getEntityTypes = function (providerLogicalName) {
        return __awaiter(this, void 0, void 0, function () {
            var url, languageCode, getEntityTypesRequest, rawResult, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.crmUrl).concat(PlaceholderMetadataProvider.odataEndpoint).concat(PlaceholderMetadataProvider.entityTypesEndpoint);
                        languageCode = this.lcid;
                        getEntityTypesRequest = JSON.stringify({ providerLogicalName: providerLogicalName, languageCode: languageCode });
                        return [4 /*yield*/, PlaceholderMetadataProvider.fetchClient.fetchPost(url, { GetEntityTypesRequest: getEntityTypesRequest })];
                    case 1:
                        rawResult = _a.sent();
                        if (!rawResult.ok) {
                            throw new Error(this.localize(LocalizationKeys.ErrorPersonalizationEntityType));
                        }
                        return [4 /*yield*/, rawResult.json()];
                    case 2:
                        result = _a.sent();
                        if (result.GetEntityTypesResult == null) {
                            throw new Error(this.localize(LocalizationKeys.ErrorPersonalizationEntityTypeResponseIsNull));
                        }
                        return [2 /*return*/, JSON.parse(result.GetEntityTypesResult)];
                }
            });
        });
    };
    PlaceholderMetadataProvider.prototype.getEntityAttributes = function (providerLogicalName, itemId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, languageCode, getEntityAttributesRequest, rawResult, result, resultObject;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.crmUrl).concat(PlaceholderMetadataProvider.odataEndpoint).concat(PlaceholderMetadataProvider.entityAttributesEndpoint);
                        languageCode = this.lcid;
                        getEntityAttributesRequest = JSON.stringify({ providerLogicalName: providerLogicalName, itemId: itemId, languageCode: languageCode });
                        return [4 /*yield*/, PlaceholderMetadataProvider.fetchClient.fetchPost(url, { GetEntityAttributesRequest: getEntityAttributesRequest })];
                    case 1:
                        rawResult = _a.sent();
                        if (!rawResult.ok) {
                            throw new Error(this.localize(LocalizationKeys.ErrorPersonalizationEntityAttribute));
                        }
                        return [4 /*yield*/, rawResult.json()];
                    case 2:
                        result = _a.sent();
                        resultObject = JSON.parse(result.GetEntityAttributesResult);
                        if (resultObject == null) {
                            throw new Error(this.localize(LocalizationKeys.ErrorPersonalizationEntityAttributeResponseIsNull));
                        }
                        if (resultObject.attributes == null) {
                            throw new Error(this.localize(LocalizationKeys.ErrorPersonalizationEntityAttributeIsNullInResponse));
                        }
                        return [2 /*return*/, new Map(Object.keys(resultObject.attributes).map(function (key) { return [key, resultObject.attributes[key]]; }))];
                }
            });
        });
    };
    PlaceholderMetadataProvider.odataEndpoint = "/api/data/v9.0/";
    PlaceholderMetadataProvider.entityProvidersEndpoint = "msdynmkt_PersonalizationGetEntityProviders";
    PlaceholderMetadataProvider.entityAttributesEndpoint = "msdynmkt_PersonalizationGetEntityAttributes";
    PlaceholderMetadataProvider.entityTypesEndpoint = "msdynmkt_PersonalizationGetEntityTypes";
    PlaceholderMetadataProvider.fetchClient = new FetchClient();
    return PlaceholderMetadataProvider;
}());
export { PlaceholderMetadataProvider };
